import { QueryClient } from '@tanstack/react-query';
import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import g from 'src/constants/global';
import { PUBLISHING_KD } from 'src/constants/services';
import { termsPolicyQuery } from 'src/hooks/Policy';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import { fetchApiV3Publishing } from 'src/utils/fetch-api';

const HeadC = dynamic(() => import('src/components/Head'));
const TermsContainer = dynamic(() => import('src/containers/TermsCondition'));

const TermsAndConditionPage = () => {
	return (
		<>
			<HeadC
				title="Syarat dan Ketentuan"
				description={
					'Syarat dan Ketentuan yang ditetapkan mengatur pemakaian jasa yang ditawarkan ' +
					'oleh KlikDokter terkait penggunaan situs dan aplikasi.'
				}
			/>

			<TermsContainer />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	const queryClient = new QueryClient();

	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	await queryClient.prefetchQuery({
		queryKey: [termsPolicyQuery],
		queryFn: () =>
			fetchApiV3Publishing({
				url: `/public/kd/${PUBLISHING_KD.model.termsPolicy}`,
			}),
	});

	return {
		props: {
			hideConsent: true,
			pageHeaderContent: {
				title: 'Syarat dan Ketentuan',
				hideHeadingTitle: true,
				breadcrumbs: [{ label: 'Syarat dan Ketentuan' }],
				isWhiteSpaceOnMobile: true,
			},
		},
		revalidate: g.REVALIDATE_EXP_ARTICLE,
	};
});

export default TermsAndConditionPage;
